import React from 'react';
import { StyleSheet, Platform, View } from 'react-native';

type Props = {};

type BorderStyle = 'solid' | 'dotted' | 'dashed';

const Line: React.FC<Props> = (props: Record<string, any>) => {
  const { height } = props;
  const borderStyle =
    props?.style?.borderStyle ||
    props?.attributes?.borderStyle ||
    props.borderStyle;
  const backgroundColor =
    props?.style?.backgroundColor ||
    props?.attributes?.backgroundColor ||
    props.backgroundColor;
  const styles = StyleSheet.create({
    container: {
      width: borderStyle !== 'none' ? props.width : 0,
      height,
      backgroundColor: backgroundColor ?? 'transparent',
      borderColor: backgroundColor,
      ...(borderStyle !== 'none'
        ? {
            borderStyle: borderStyle as BorderStyle,
            //  borderColor: backgroundColor,
          }
        : { borderWidth: 0 }),
      ...Platform.select({
        ios: {
          borderWidth: height / 2,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        android: {
          borderWidth: height / 2,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        default: {
          borderTopWidth: height,
        },
      }),
    },
  });

  return (
    <View style={{ height: height, overflow: 'hidden' }}>
      <View style={styles.container}></View>
    </View>
  );
};

export default Line;
